module.exports = __webpack_public_path__ + "img/Nora/Norafavicon.png";